module.exports = __webpack_public_path__ + "static/img/0010-1未启用吉林市人民政府.be8a8dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0010-1未启用吉林市人民政府.jpg
// module id = lVJl
// module chunks = 0